import api from './api';

export const settingsService = {
  // Récupérer tous les paramètres système
  getSystemSettings: async () => {
    try {
      const response = await api.get('/admin/system-settings');
      return response.data;
    } catch (error) {
      // Retourner des valeurs par défaut en cas d'erreur
      return {
        settings: {
          site_name: 'Tchamba MarketPlace',
          site_description: 'La plateforme qui connecte vendeurs et acheteurs locaux à Tchamba.',
          site_logo: '',
          maintenance_mode: false,
          registration_enabled: true,
          email_verification_required: true
        }
      };
    }
  },

  // Récupérer un paramètre spécifique
  getSystemSetting: async (key) => {
    try {
      const response = await api.get(`/admin/system-settings/${key}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du paramètre ${key}:`, error);
      return null;
    }
  }
};
